import { Controller, Path, useFormContext } from "react-hook-form";
import { BLANK_OPTION, CustomerSearchFilters, IMapField } from "../../../types";
import { Autocomplete, TextField } from "@mui/material/index";
import { useTranslation } from "react-i18next";

interface CBSearchAutocompleteControllerProps {
    idField: string,
    formName: Path<CustomerSearchFilters>,
    label: string,
    translateLabel?: string,
    options: IMapField[],
    onChange?: (value: any) => void
   
}

const CBSearchAutocompleteController = ({
    idField,
    formName,
    label,
    translateLabel,
    options,
    onChange

}: CBSearchAutocompleteControllerProps) => {

    const { t } = useTranslation('customerbase');
    const formContext = useFormContext<CustomerSearchFilters>();
   

    return (
        <Controller
            control={formContext.control} 
            name={formName}
            render={({field}) => (
                <Autocomplete
                    fullWidth
                    openOnFocus
                    autoHighlight
                    autoSelect
                    id={idField}
                    options={[BLANK_OPTION, ...options]}
                    renderInput={(params:any) => 
                        <TextField 
                            fullWidth
                            {...params}
                            label={t(label)}
                        />
                    }
                    value={field.value ? options.find((c) => c.value === field.value) || null : null}
                    getOptionLabel={(option:any) => !!option?.key && !!translateLabel ? t(`${translateLabel}.${option?.key}`) : option?.key}
                    onChange={(_event, value) => {
                        field.onChange(value);
                        onChange?.(value)
                    }}
                />
            )}  
        />

    )

}

export default CBSearchAutocompleteController;